import React from "react";

import "./index.scss";

function EventLogo (props) {
    const { languageCode } = props;
    
    return (
        <div className="event-svg-logo">
            <img src={ "/images/SVI_SunwingWeddingsEvents_" + languageCode.toUpperCase() + "_StackedWeb.svg" } alt="Sunwing event & wedding" />
        </div>
    );
}

export default EventLogo;